import container from 'di/inversify.config';
import TYPES from 'di/types';

var useNetworkService = function useNetworkService() {
  return container.get(TYPES.NetworkService);
};

export { useNetworkService };